import { jsx as _jsx } from "react/jsx-runtime";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackFaireDirectCreditHcArticleFdLandingPageBottomView } from "@faire/web-api--source/events/faireDirect/view/creditHcArticleFdLandingPageBottom";
import helpCenterArticles from "@faire/web-api--source/routes/www/support/articles/articleId";
import React from "react";
export var getPerkValues = function(options) {
    return [
        options.isFoiForFDDiscount ? getFoiForFDDiscountPerk(options) : getDiscountPerk(options),
        {
            head: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "CZTWOs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "60-day payment terms on all orders"
                    }
                ]
            }),
            body: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "l4Uyyt",
                defaultMessage: [
                    {
                        type: 0,
                        value: "When you order through Faire, use terms to buy now & pay 60 days later."
                    }
                ]
            })
        },
        {
            head: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "hR0bo2",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Free returns"
                    },
                    {
                        type: 1,
                        value: "lineBreak"
                    },
                    {
                        type: 0,
                        value: "on opening orders"
                    }
                ],
                values: DEPRECATED_backwardsCompatibleValues({
                    lineBreak: /*#__PURE__*/ _jsx("br", {})
                })
            }),
            body: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "5FuVLT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "If something's not right, get a prepaid shipping label and send it back."
                    }
                ]
            })
        }
    ];
};
var getDiscountPerk = function(param) {
    var formattedIncentiveAmount = param.formattedIncentiveAmount, formattedMaximumPercentageDiscount = param.formattedMaximumPercentageDiscount, formattedPercentageBasedDiscount = param.formattedPercentageBasedDiscount, isFaireDirectCreditPercentageBased = param.isFaireDirectCreditPercentageBased;
    return {
        head: isFaireDirectCreditPercentageBased ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "xlh4eY",
            defaultMessage: [
                {
                    type: 1,
                    value: "faireDirectPercentageDiscountNumber"
                },
                {
                    type: 0,
                    value: " off and 1 year of free shipping"
                }
            ],
            values: {
                faireDirectPercentageDiscountNumber: formattedPercentageBasedDiscount
            }
        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "jHy0bC",
            defaultMessage: [
                {
                    type: 1,
                    value: "promoMoney"
                },
                {
                    type: 0,
                    value: " off & 1 year of free shipping"
                }
            ],
            values: {
                promoMoney: formattedIncentiveAmount
            }
        }),
        body: isFaireDirectCreditPercentageBased ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "kZPYs7",
            defaultMessage: [
                {
                    type: 0,
                    value: "Get up to "
                },
                {
                    type: 1,
                    value: "maximumDiscountMoney"
                },
                {
                    type: 0,
                    value: " off your first order with us\u2014covered by Faire."
                }
            ],
            values: {
                maximumDiscountMoney: formattedMaximumPercentageDiscount
            }
        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "iOjM3i",
            defaultMessage: [
                {
                    type: 0,
                    value: "Faire is offering this promotion to new retailers to grow its global community of retailers and brands. "
                },
                {
                    type: 8,
                    value: "LinkFormatting",
                    children: [
                        {
                            type: 0,
                            value: "Learn More"
                        }
                    ]
                }
            ],
            values: {
                LinkFormatting: function(chunks) {
                    return /*#__PURE__*/ _jsx(EmbeddedLink, {
                        linkTo: helpCenterArticles("360034300092"),
                        onClick: function() {
                            trackFaireDirectCreditHcArticleFdLandingPageBottomView();
                        },
                        target: "_blank",
                        children: chunks
                    });
                }
            }
        })
    };
};
var getFoiForFDDiscountPerk = function(param) {
    var formattedIncentiveAmount = param.formattedIncentiveAmount, formattedMaximumPercentageDiscount = param.formattedMaximumPercentageDiscount, formattedPercentageBasedDiscount = param.formattedPercentageBasedDiscount, isFaireDirectCreditPercentageBased = param.isFaireDirectCreditPercentageBased;
    return {
        head: isFaireDirectCreditPercentageBased ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "xlh4eY",
            defaultMessage: [
                {
                    type: 1,
                    value: "faireDirectPercentageDiscountNumber"
                },
                {
                    type: 0,
                    value: " off and 1 year of free shipping"
                }
            ],
            values: {
                faireDirectPercentageDiscountNumber: formattedPercentageBasedDiscount
            }
        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "jHy0bC",
            defaultMessage: [
                {
                    type: 1,
                    value: "promoMoney"
                },
                {
                    type: 0,
                    value: " off & 1 year of free shipping"
                }
            ],
            values: {
                promoMoney: formattedIncentiveAmount
            }
        }),
        body: isFaireDirectCreditPercentageBased ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "5LyJQr",
            defaultMessage: [
                {
                    type: 0,
                    value: "Claim our referral offer to get up to "
                },
                {
                    type: 1,
                    value: "maximumDiscountMoney"
                },
                {
                    type: 0,
                    value: " off your first order with us and 1 year of free shipping."
                }
            ],
            values: {
                maximumDiscountMoney: formattedMaximumPercentageDiscount
            }
        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "EOt2/V",
            defaultMessage: [
                {
                    type: 0,
                    value: "Claim our referral offer to get "
                },
                {
                    type: 1,
                    value: "promoMoney"
                },
                {
                    type: 0,
                    value: " off your first order with us and 1 year of free shipping."
                }
            ],
            values: {
                promoMoney: formattedIncentiveAmount,
                LinkFormatting: function(chunks) {
                    return /*#__PURE__*/ _jsx(EmbeddedLink, {
                        linkTo: helpCenterArticles("360034300092"),
                        onClick: function() {
                            trackFaireDirectCreditHcArticleFdLandingPageBottomView();
                        },
                        target: "_blank",
                        children: chunks
                    });
                }
            }
        })
    };
};
